// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"_3A4gDK3ByjMO","content":"_2cObqqmn8REC"};